import { BreakPoints, Icon } from '@kanda-libs/ks-design-library';
import OpenBankingDesktop from './Desktop';
import OpenBankingInfoMobile from './Mobile';
import useOpenBanking from './useOpenBanking';

const OpenBanking: React.FunctionComponent = function () {
  const { icon, iconStroke, showOpenBanking } = useOpenBanking();
  if (!showOpenBanking) return null;
  return (
    <div className="flex flex-col md:px-4 md:pt-5 pb-0 md:pb-3 border-0 md:border border-neutral-300 rounded-lg md:shadow-none">
      <div className="flex flex-row gap-x-2 mb-2 justify-between">
        <div className="flex flex-row gap-x-2">
          <Icon icon={icon} size={20} className="my-auto" stroke={iconStroke} />
          <h2 className="text-14-22-em text-neutral-700 my-auto">
            Pay via Open Banking
          </h2>
        </div>
        <BreakPoints
          desktop={<OpenBankingDesktop />}
          mobile={<OpenBankingInfoMobile />}
        />
      </div>
      <h3 className="text-12-18 text-neutral-600">
        Your customer can choose to pay in full via Open Baking. This is a more
        secure and affordable transaction alternative to card payments, charged
        at 1%. Up to £10,000.
      </h3>
    </div>
  );
};

export default OpenBanking;
